export var scrollToViewTop = function scrollToViewTop(divId) {
  var element = document.getElementById(divId);

  if (element) {
    element.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    });
  }
};
export var scrollToViewBottom = function scrollToViewBottom(divId) {
  var element = document.getElementById(divId);

  if (element) {
    element.scrollIntoView({
      block: 'end',
      behavior: 'smooth'
    });
  }
};